import { Modelo } from '@ext/index';
import * as Types from './Transporte.types';
import moment, { Moment } from 'moment';

export class ITransporte extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Codigo: string = '';
    public Descripcion: string = '';
    public Telefono: string = '';
    public Direccion: string = '';
    public Localidad: string = '';
    public Provincia: string = '';
    public CodigoPostal: number = 0;


    public getJson(): any {
        let json: any = {};

        json.codigo = this.Codigo;
        json.descripcion = this.Descripcion;
        json.telefono = this.Telefono;
        json.direccion = this.Direccion;
        json.localidad = this.Localidad;
        json.provincia = this.Provincia;
        json.codigo_postal = this.CodigoPostal;


        return json;
    }


    public set(): boolean {

        this.Codigo = !this.Json.codigo ? '' : this.Json.codigo;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.Telefono = !this.Json.telefono ? '' : this.Json.telefono;
        this.Direccion = !this.Json.direccion ? '' : this.Json.direccion;
        this.Localidad = !this.Json.localidad ? '' : this.Json.localidad;
        this.Provincia = !this.Json.provincia ? '' : this.Json.provincia;
        this.CodigoPostal = !this.Json.codigo_postal ? 0 : this.Json.codigo_postal;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }

    public static Propio = "001";
    public static Trole = "370";
    public static CorreoArgentino = "C05";
    public static OCA = "767";
    public static OCASA = "C28";
    public static Andreani = "C34";
    public static Moto = "C39";
    public static BusPack = "C40";
    public static ViaCargo = "A62";
    public static Flex = "C29";
    public static MBCargo = "C45";
    public static SendBox = "718";
}

class Vista {
    constructor( Model: ITransporte ) {
        this.Model = Model;
    }

    public Model: ITransporte;
}